export const defaultOpenAIAnswer = 'Here are some references to check out:';
export const customDefaultAnswer = "Ask AI didn't have an answer for this question.";
export const defaultChunkOverlap = 0;
export const defaultChunkSize = 8000;
export const markdownChunkOverlap = 0;
export const markdownChunkSize = 10000;
export const jsonChunkOverlap = 0;
export const jsonChunkSize = 10000; // this is current models max -2 to be safe
export const gpt4Encoding = 'cl100k_base'; // sometimes this notation is used for gpt 4 encoding
// data from: https://openai.com/blog/new-models-and-developer-products-announced-at-devday
export const gptModel = 'gpt-4o';
export const currentTokenLimit = 128000;

export const FREE_OWLBOT_LIMIT = 100;
export const didOwlbotAnswer = (givenAnswer: string, projectDefaultAnswer: string): boolean =>
  givenAnswer !== (projectDefaultAnswer || defaultOpenAIAnswer);
export const owlbotLimitAnswer = 'The free Ask AI limit has been exceeded for this project.';
